import {GeoJsonLayer, IconLayer} from '@deck.gl/layers';
import {BaseLayerMVTDeck} from '../../../common/layers/baseLayerMVTDeck';
import {MvtService} from '../../../common/services/mvt.service';
import {LAYERS_ID, LAYERS_SQL} from './constants';

export class MadridCentralLayer extends BaseLayerMVTDeck {
    icon_mapping: any;
    icon_atlas = '';
    layers = {
        [LAYERS_ID.ZBEDEP_PLAZA_ELIPTICA_LAYER]: (
            new GeoJsonLayer({
                id: LAYERS_ID.ZBEDEP_PLAZA_ELIPTICA_LAYER,
                minZoom: 0,
                maxZoom: 23,
                getFillColor: [215, 140, 183, 100],
                opacity: 0.5,
                lineWidthMinPixels: 1
            })
        ),
        [LAYERS_ID.ZBEDEP_PLAZA_ELIPTICA_POINTS_LAYER]: (
            new IconLayer({
                id: LAYERS_ID.ZBEDEP_PLAZA_ELIPTICA_POINTS_LAYER,
                getPosition: d => d.geometry.coordinates,
                iconAtlas: 'assets/sprite/markers@3x.png',
                iconMapping: 'assets/sprite/markers@3x.json',
                getIcon: f => 'madrid_central',
                getSize: 24,
            })
        ),
        [LAYERS_ID.ZBEDEP_DISTRITO_CENTRO_LAYER]: (
          new GeoJsonLayer({
            id: LAYERS_ID.ZBEDEP_DISTRITO_CENTRO_LAYER,
            minZoom: 0,
            maxZoom: 23,
            getFillColor: [140, 207, 215, 100],
            opacity: 0.5,
            lineWidthMinPixels: 1
          })
        ),
        [LAYERS_ID.ZBEDEP_DISTRITO_CENTRO_POINTS_LAYER]: (
            new IconLayer({
                id: LAYERS_ID.ZBEDEP_DISTRITO_CENTRO_POINTS_LAYER,
                getPosition: d => d.geometry.coordinates,
                iconAtlas: 'assets/sprite/markers@3x.png',
                iconMapping: 'assets/sprite/markers@3x.json',
                getIcon: f => 'madrid_central',
                getSize: 24,
            })
        ),
    };

    constructor(private mvtService: MvtService) {
        super(LAYERS_ID.MADRID_CENTRAL_LAYER);
        this.mvtService.getIconAtlas().then(i => {
            this.icon_atlas = i.atlas;
            this.icon_mapping = i.mapping;
        });
    }

    getDataLayer() {
        const p = [];
        Object.keys(this.layers).forEach(layer_id => {
            const tiles = this.mvtService.getMVT(
                layer_id,
                LAYERS_SQL[layer_id]()
            );

            p.push(tiles);
        });

        return Promise.all(p).then(values => {
            return Object.keys(this.layers).map((id, idx) => ({
                id,
                tiles: values[idx]
            }));
        });
    }

    setLayerFilters() {
    }
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/layers/madridCentralLayer.ts